// extracted by mini-css-extract-plugin
export default {"tradingView":"markets__tradingView__ehveWo","fadeIn":"markets__fadeIn__xjobVz","tvchart_container_id":"markets__tvchart_container_id__AfD0zy"};